<template>
    <div class="flight-coupon">
        <p class="flight-coupon-text1">{{ conditionText1 }}</p>
        <p class="flight-coupon-text2">{{ conditionText2 }}</p>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import { Coupon } from '@/api/MyBooking/myBooking.interfaces';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import { convertToDate, getShortDate } from '@shared/helpers/datetime/datetime';

    export default defineComponent({
        name: 'FlightCoupon',
        props: {
            coupon: {
                type: Object as PropType<Coupon>,
                required: true,
            },
        },
        setup(props) {
            const conditionText1 = t({
                key: 'flight_coupon.description',
            });

            const conditionText2 = computed<string | undefined>(() => {
                const { termsAmount, expirationDate } = props.coupon;

                if (termsAmount && expirationDate) {
                    return `${t({ key: 'flight_coupon.disclaimer', values: [getShortDate(convertToDate(expirationDate)), getMoneyObjectAsString(termsAmount)] })}`;
                }

                return '';
            });

            return { conditionText1, conditionText2 };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'FlightCoupon';
</style>
